import ActionTypes from "../../../../constants/ActionTypes";
import { UpdateOrderItemFullLoaderStatePayload } from "./transition/types";
import {
  ISubmitManhattanOrderAction,
  ChangeDeviceColorRequestData,
  RemoveOrderItemFromBasketPayload,
  UpdateDeviceColorChangeInProgressPayload,
} from "./types";


export const submitBundleOrderAction = (): ISubmitManhattanOrderAction => ({
  type: ActionTypes.ORDER.MANHATTAN.SUBMIT
});

export const cancelOrderAction = () => ({
  type: ActionTypes.ORDER.MANHATTAN.CANCEL_ORDER
});

export const setDefaultCheckoutData = () => ({
  type: ActionTypes.ORDER.MANHATTAN.SET_DEFAULT_CHECKOUT_DATA
});

export function changeDeviceColorApiCallAction(payload: ChangeDeviceColorRequestData) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.CHANGE_DEVICE_COLOR,
    payload
  };
}

export function updateDeviceColorAction(payload: ChangeDeviceColorRequestData) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.UPDATE_DEVICE_COLOR,
    payload
  };
}

export function updateDeviceColorChangeInProgressAction(payload: UpdateDeviceColorChangeInProgressPayload) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.UPDATE_COLOR_CHANGE_IN_PROGRESS_STATUS,
    payload
  };
}

export function removeItemFromBasketAction(payload: RemoveOrderItemFromBasketPayload) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.REMOVE_ITEM_FROM_BASKET,
    payload,
  };
}

export function replaceOrderItemAction(payload: RemoveOrderItemFromBasketPayload) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.PREPARE_BASKET_ITEM_FOR_REPLACEMENT,
    payload
  };
}

export function updateFullItemLoaderStatusAction(payload: UpdateOrderItemFullLoaderStatePayload) {
  return {
    type: ActionTypes.ORDER.MANHATTAN.UPDATE_FULL_ITEM_LOADER_STATUS,
    payload
  };
}
